import { render, staticRenderFns } from "./CardNews.vue?vue&type=template&id=35e57184&scoped=true&"
import script from "./CardNews.vue?vue&type=script&lang=js&"
export * from "./CardNews.vue?vue&type=script&lang=js&"
import style0 from "./CardNews.vue?vue&type=style&index=0&id=35e57184&scoped=true&lang=scss&"
import style1 from "./CardNews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e57184",
  null
  
)

export default component.exports